import request from '@/utils/request'

export const getExcel = (role: string, params: any) => {
  let url = ''
  switch (role) {
      case 'ServiceProvider':
          url = '/providers.excel'
        break
      case 'Customer':
        url = '/customers.excel'
        break
      case 'listServices':
        url = '/services.excel'
        break
      case 'listServicesTypes':
        url = '/services-types.excel'
        break
      default:
        url = '/hired_services.excel'
        break
  }
  return request({
    url,
    method: 'get',
    responseType: 'blob',
    params
  })
}
